export default "__VITE_ASSET__C$g8Va0u__"